import React from 'react'
import styles from './styles'

const Footer = () => {
  return (
    <>
      <div className={styles.footer}>
        <div className={styles.columnWide}>
          <img
            src="https://assets.website-files.com/5e8b2955eaa7857dbbd850ad/5e8c1b2ed131f53c09378b3e_footer-offerzen-logo.svg"
            alt="OfferZen logo"
            className={styles.logo}
          />
        </div>
        <div className={styles.columnNarrow}>
          <ul role="list" className={styles.list}>
            <li>
              <strong className={styles.listHeading}>Developers</strong>
            </li>
            <li>
              <a href="/candidate/signup" className={styles.listItemLink}>
                Find a job
              </a>
            </li>
            <li>
              <a href="http://docs.offerzen.com/en/collections/111174-candidate-faq-s" className={styles.listItemLink}>
                FAQ
              </a>
            </li>
            <li>
              <a href="http://docs.offerzen.com/en/collections/111151-candidate-guides" className={styles.listItemLink}>
                Guides
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/community" className={styles.listItemLink}>
                Community
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/companies/public_list" className={styles.listItemLink}>
                Companies on OfferZen
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.columnNarrow}>
          <ul role="list" className={styles.list}>
            <li className="unversal-footer-list-item">
              <strong className={styles.listHeading}>Employer</strong>
            </li>
            <li>
              <a href="/employers" aria-current="page" className={styles.listItemLink}>
                Hire developers
              </a>
            </li>
            <li>
              <a href="http://docs.offerzen.com/en/collections/111166-company-faq-s" className={styles.listItemLink}>
                FAQ
              </a>
            </li>
            <li>
              <a href="http://docs.offerzen.com/en/collections/111160-company-guides" className={styles.listItemLink}>
                Guides
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.columnWide}>
          <ul role="list" className={styles.list}>
            <li className="unversal-footer-list-item">
              <strong className={styles.listHeading}>OfferZen</strong>
            </li>
            <li>
              <a href="https://www.offerzen.com/team/" className={styles.listItemLink}>
                Meet the team
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/careers/" className={styles.listItemLink}>
                Careers
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/blog" className={styles.listItemLink}>
                Blog
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/community/swag" className={styles.listItemLink}>
                Get swag
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/reports/software-developer-netherlands" className={styles.listItemLink}>
                Netherlands Dev Report
              </a>
            </li>
            <li>
              <a href="https://www.offerzen.com/reports/software-developer-south-africa/" className={styles.listItemLink}>
                South Africa Dev Report
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.columnNarrow}>
          <div>
            <div className={styles.listHeading}>Social</div>
            <div className={styles.socialIconContainer}>
              <a href="https://twitter.com/offerzen" className={styles.socialIcon}>
                <img
                  src="https://assets.website-files.com/5e8b2955eaa7857dbbd850ad/5e8c19a0e7b5c7264dbb9055_social-icon-twitter.svg"
                  alt="Twitter social media icon"
                />
              </a>
              <a href="https://www.linkedin.com/company/offerzen/" className={styles.socialIcon}>
                <img
                  src="https://assets.website-files.com/5e8b2955eaa7857dbbd850ad/5e8c19a182788789b7cbb220_social-icon-linkedin.svg"
                  alt="LinkedIn social media icon"
                />
              </a>
              <a href="https://www.facebook.com/offerzen" className={styles.socialIcon}>
                <img
                  src="https://assets.website-files.com/5e8b2955eaa7857dbbd850ad/5e8c19a0a4cc2d280b956e9f_social-icon-facebook.svg"
                  alt="Facebook social media icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.policyRoot}>
        <div className={styles.policyContainer}>
          <a href="https://www.offerzen.com/terms/" className={styles.listItemLink}>
            <div>Terms</div>
          </a>
          <a href="https://www.offerzen.com/code_of_conduct/" className={styles.listItemLink}>
            <div>Code of Conduct</div>
          </a>
          <a href="https://www.offerzen.com/privacy-centre/" className={styles.listItemLink}>
            <div>Privacy Centre</div>
          </a>
        </div>
      </div>
    </>
  )
}

export default Footer
